import React from "react"
import { withLifelongLearningMe } from "../../Education/lifelongLearning/withLifelongLearningMe"
import { LL_CURRENT_ENROLLMENT_QUERY } from "../../Education/lifelongLearning/queries"
import Registration from "./Registration"
import Loading from "./Loading"
import ErrorLoading from "./ErrorLoading"
import WrapWithFetch from "../WrapWithFetch"

export const ProgramEnrollmentCard = ({
  me,
  loading,
  isFetching,
  error,
  refetch,
  reload,
}) => {
  if (loading || isFetching) {
    return <Loading />
  } else if (error) {
    return <ErrorLoading {...{ refetch, reload }} />
  }
  return <Registration {...{ me }} />
}

export default withLifelongLearningMe(LL_CURRENT_ENROLLMENT_QUERY)(
  WrapWithFetch(ProgramEnrollmentCard),
)
